/**
 * Returns true if the given object has no keys.
 * Use null as the initial value for optional data states instead of {}
 * whenever possible — this helper covers the cases where that isn't feasible.
 */
export const isEmptyObject = (obj) =>
    obj === null || obj === undefined || Object.keys(obj).length === 0;

/**
 * Checks whether the given variant list contains the last warehouse added.
 */
export const variantMatchesLastWarehouse = (variants, lastWarehouseAdded) =>
    variants.some(item =>
        item.name.toLowerCase().includes(
            lastWarehouseAdded.data.label.toLowerCase()
        )
    );
